var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrazil2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Brazil@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-324.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Brazil"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_7_copy-19",
    fill: "#52C162",
    x: 0.15,
    y: 0.13,
    width: 70,
    height: 47,
    rx: 6.36
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#F6D660",
    points: "7.93 23.63 35.14 2.63 62.35 23.63 35.14 44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,18.55 C28.1697126,18.5497189 25.3882472,19.287307 22.93,20.69 C21.41007,26.9033713 24.8025227,33.2665085 30.8085017,35.4675051 C36.8144808,37.6685017 43.5152025,35.0041857 46.37,29.28 C43.9945024,22.8411882 37.8630293,18.5607259 31,18.55 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,18.55 C37.8630293,18.5607259 43.9945024,22.8411882 46.37,29.28 C46.8191035,28.3676841 47.1549304,27.4038608 47.37,26.41 C42.9638408,17.9447943 32.8341938,14.2301569 24,17.84 C23.5318215,18.7432432 23.1758466,19.7003456 22.94,20.69 C25.3953026,19.2889863 28.1731027,18.5514563 31,18.55 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4,26.42 C48.7766375,20.2662874 45.3808634,14.0449446 39.4604826,11.8741383 C33.5401018,9.70333201 26.9275707,12.254963 24,17.84 C32.847819,14.2072425 43.0052744,17.9300518 47.41,26.42 L47.4,26.42 Z",
    id: "Shape",
    fill: "#4758A9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil2X);
export default __webpack_public_path__ + "static/media/Brazil@2x.73feabd040467744a83db43d0b504582.svg";
export { ForwardRef as ReactComponent };